import TokenIconPlaceholder from "@src/components/TokenIconPlaceholder"
import clsx from "clsx"
import { useTheme } from "next-themes"
import Image from "next/image"
import type React from "react"
import InfoPopover from "../../InfoPopover"

type AssetComboIconProps = {
  icon?: string
  chainIcon?: { dark: string; light: string }
  chainName?: string
  showChainIcon?: boolean
  className?: React.HTMLAttributes<"div">["className"]
  style?: React.HTMLAttributes<"div">["style"]
  sizeClassName?: string
}

const AssetComboIcon = ({
  icon,
  chainIcon,
  chainName,
  showChainIcon = false,
  className,
  style,
  sizeClassName = "size-10",
}: AssetComboIconProps) => {
  const { resolvedTheme } = useTheme()
  const chainIconVisible = showChainIcon && chainIcon

  return (
    <div className={clsx("relative inline-block", className)} style={style}>
      <div
        className={clsx(
          "relative flex items-center justify-center overflow-hidden rounded-full",
          sizeClassName
        )}
      >
        <div className="absolute inset-px rounded-full bg-white" />
        {icon ? (
          <img
            src={icon}
            alt=""
            className="-outline-offset-1 relative size-full rounded-full object-contain outline-1 outline-gray-900/10 dark:outline-white/10"
          />
        ) : (
          <TokenIconPlaceholder />
        )}
        {chainIconVisible && (
          <div className="-bottom-2.5 -right-2.5 absolute z-1 size-7.5 rounded-full bg-gray-900/20" />
        )}
      </div>

      {chainIconVisible && (
        <InfoPopover>
          <InfoPopover.Trigger nativeButton={false}>
            <div className="-bottom-1.5 -right-1.5 absolute z-2 size-5.5 rounded-full ring-2 ring-gray-25 group-hover:ring-gray-100 dark:ring-gray-850 group-hover:dark:ring-gray-800">
              <Image
                width={40}
                height={40}
                src={
                  resolvedTheme === "dark" ? chainIcon.dark : chainIcon.light
                }
                alt=""
                className="size-full rounded-full object-contain"
              />
            </div>
          </InfoPopover.Trigger>
          <InfoPopover.Content>{chainName?.toUpperCase()}</InfoPopover.Content>
        </InfoPopover>
      )}
    </div>
  )
}

export default AssetComboIcon
